import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'facturexml',

  type : 'module',
  
  label: 'Document XML de facture',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-invoice',
  }
}